import React from 'react';
import { motion } from 'framer-motion';
interface ShimmerButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function ShimmerButton({
  children,
  onClick,
  className = ''
}: ShimmerButtonProps) {
  return <motion.button onClick={onClick} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} className={`relative overflow-hidden bg-pistachio text-slate-dark font-bold py-4 px-8 rounded-full shadow-lg transition-shadow hover:shadow-xl ${className}`} data-id="element-139">
      <span className="relative z-10" data-id="element-140">{children}</span>
      <div className="absolute inset-0 shimmer-effect z-0 pointer-events-none" data-id="element-141" />
    </motion.button>;
}